import { EyeOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Form,
  Grid,
  Image,
  message,
  Spin,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import { Modal } from 'components';
import { useUploadImage } from 'features/Dashboard/use-cases/upload-image';
import { useUploadDocuments } from 'features/document-report/use-cases/upload-documents';
import { useUserContext } from 'features/users';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import {
  UserFormField,
  UserFormValues,
} from 'features/users/components/users-filter-form';
import { useState } from 'react';
import { convertFileSize, validateFileBeforeUpload } from 'routes/utils';
const { useBreakpoint } = Grid;
export const UploadAgainDocumentsModal = ({
  onClose,
  documentInfo,
  intialFetch,
  getDocumentsCount,
  year,
  month,
  handleClick,
}: {
  onClose: () => void;
  documentInfo: any;
  intialFetch: any;
  // selectedValue: any;
  month: any;
  year: any;
  handleClick: any;
  getDocumentsCount: any;
}) => {
  const { user } = useUserContext();
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<UserFormValues>();
  const [fileList, setFileList] = useState<any[]>([]);
  const [previewImage, setPreviewImage] = useState<string>('');
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false); // Loading state for image upload
  const [blobUrl, setBlobUrl] = useState<string>(''); // Store the uploaded blob URL
  const [fileNames, setFileNames] = useState<string[]>([]);
  const { isLoading: imageLoading, mutate: uploadImage } = useUploadImage();

  const { isLoading, mutate } = useUploadDocuments();
  const getInitialValues = {
    [UserFormField.Role]: undefined,
    [UserFormField.Email]: undefined,
  };
  const handleImageUpload = (file: UploadFile) => {
    const formData = new FormData();
    formData.append('file', file as any);

    setIsImageUploading(true); // Set uploading state to true
    uploadImage(
      { id: user?.CompanyId as string, formData }, // Pass id and file as payload
      {
        onSuccess: (response: any) => {
          setFileNames((prev: any) => [...prev, response.fileName]);
          setBlobUrl(response.blobUrl);
          message.success('File uploaded successfully');
          setIsImageUploading(false); // Reset uploading state
        },
        onError: () => {
          message.error('Image upload failed');
          setIsImageUploading(false); // Reset uploading state
        },
      },
    );
  };
  const handleUpdate = () => {
    const IsClientUpload = true;

    if (!fileList || fileList.length === 0) {
      message.error('Please upload at least one file.');

      return;
    }

    const files = fileList
      .map((fileItem, index) => {
        const file = fileItem.originFileObj;
        if (!file) {
          message.error('Please upload a valid file.');

          return null;
        }

        const fileSize = file.size;
        const documentName = documentInfo?.documentName;

        const fileData = {
          documentName,
          fileName: fileNames[index] || '',
          fileSize: convertFileSize(fileSize),
        };

        return fileData;
      })
      .filter((file) => file !== null);

    if (files.length === 0) {
      message.error('Please upload at least one valid file.');

      return;
    }

    const payload = {
      companyId: user?.CompanyId,
      documentId: documentInfo?.documentId,
      serviceId: documentInfo?.serviceId,
      isClientUpload: IsClientUpload,
      files: files,
      year: +year,
      month: +month,
    };

    mutate(payload, {
      onSuccess: () => {
        onClose();
        handleClick('RejectedDocuments');
        intialFetch();
        getDocumentsCount();
      },
    });
  };

  const beforeUpload = (file: any) => {
    const isValid = validateFileBeforeUpload(file);
    if (isValid) {
      handleImageUpload(file); // Call handleImageUpload only if valid
    }

    return isValid; // If false, upload will be prevented
  };
  const handlePreview = async (file: UploadFile) => {
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };
  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type='button'>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        title={'Upload Documents Again'}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={'Upload'}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
          loading: isLoading,
          disabled: imageLoading || isImageUploading,
        }}
        maskClosable={false}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          initialValues={getInitialValues}
          onFinish={handleUpdate}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          disabled={isLoading}
        >
          <Form.Item label={'Upload Documents'} name={'file'}>
            <div className='updcbx'>
              <Upload
                action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
                listType='picture-card'
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                maxCount={1}
                style={{ width: '100%' }} // Ensure the Upload takes 100% width
                beforeUpload={beforeUpload}
                className='upld_docs'
              >
                {fileList?.length >= 1 ? null : (
                  <div style={{ width: '100%' }}>
                    {' '}
                    {/* Upload button full width */}
                    {uploadButton}
                  </div>
                )}
              </Upload>
              {blobUrl && fileList.length > 0 && (
                <EyeOutlined
                  className='eyeiconi'
                  onClick={() => setPreviewOpen(true)}
                />
              )}
            </div>
            {isImageUploading && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1,
                }}
              >
                <Spin size='large' />
              </div>
            )}
            <Modal
              open={previewOpen}
              onCancel={() => setPreviewOpen(false)}
              footer={null}
              centered
              width={800}
            >
              {blobUrl.endsWith('.jpg') ||
              blobUrl.endsWith('.jpeg') ||
              blobUrl.endsWith('.png') ||
              blobUrl.endsWith('.webp') ? (
                <Image src={blobUrl} alt='Preview' />
              ) : (
                <iframe
                  src={`https://docs.google.com/gview?url=${blobUrl}&embedded=true`}
                  style={{ width: '100%', height: '600px', border: 'none' }}
                  title='Document Preview'
                />
              )}
            </Modal>
            {previewImage && (
              <Image
                wrapperStyle={{ display: 'none' }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
              />
            )}
          </Form.Item>
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
